import { SystemStyleObject } from '@styled-system/css';

export const WHCM =
  '@media (-ms-high-contrast: active), (prefers-contrast: more), (forced-colors: active)';

export const WHCMstyles = {
  msHighContrastAdjust: 'none',
  forcedColorAdjust: 'none',
} as SystemStyleObject;
